/*
 * Dashboard.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Sat Feb 04 2023 mys Company
 */

import { localization } from "../../../config/localize/localizable";

const Dashboard = () => {
  return (
    <>
      <div className="col-span-3  p-2">
        <h1 className=" p-4 bg-white shadow rounded ">{localization.dashboard}</h1>
      </div>
    </>
  );
};

export default Dashboard;
